<template>
    <div class="container">
        <div class="row">
            <div class="col md-12">
                Total del {{routes.length}} rutas en el API.
            </div>
            <div class="col-md-6 flex" v-for="route in routes">
              <vx-tooltip :text="route.middleware.join(', ')">
                <vs-button icon="lock" v-if="route.middleware !== ''">
                </vs-button>
              </vx-tooltip>

              <vx-tooltip :text="route.methods.join(', ')">
                <vs-button icon="book" v-if="route.middleware !== ''">
                </vs-button>
              </vx-tooltip>
              {{route.uri}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "apiDoc",
        data: () => ({
            routes: []
        }),
        async mounted() {
            const {data} = await axios.get(`/api/endpoints`)
            this.routes = data;
        }
    }
</script>

<style scoped>
    .method {
        width: 100px;
        background-color: #CCCCCC;
    }
    .flex {
        display: flex;
        overflow: hidden;
    }
</style>
